import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface ActividadAprendizItem {
  idActividadPrograma: number;
  nombre: string;
  fechaInicio: string | null;
  fechaFin: string | null;
  limiteIntentos: number;
  actividadAprendiz: {
    id: number;
    intentos: number;
    intentosRestantes: number;
    intentosExtras?: number;
    numInteraccionesChat: number;
    ultimoIntento: {
      id: number;
      fechaIntento: string;
      tieneRetro: boolean;
    } | null;
    creadoEl: string;
    actualizadoEl: string;
  } | null;
}

export function useActividadesAprendiz(
  idAprendiz: number | undefined,
  idPrograma: number | undefined
) {
  return useQuery<ActividadAprendizItem[]>({
    queryKey: ["actividadesAprendiz", idAprendiz, idPrograma],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `/actividades-aprendiz/aprendiz/${idAprendiz}/programa/${idPrograma}`
      );
      return response.data;
    },
    enabled: idAprendiz != null && idPrograma != null,
  });
}
